export const API_BASE =
  process.env.NODE_ENV === 'development' ? 'http://localhost:3001/api/v1' : '/api/v1';

export const CREDENTIALS = process.env.NODE_ENV === 'development' ? 'include' : 'same-origin';

export const POST_HEADERS = (xCSRFToken: string) => {
  return {
    Accept: 'application/json',
    'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
    'X-CSRF-TOKEN': xCSRFToken,
  };
};
